export default "__VITE_ASSET__ef900427__"